import { useCallback, useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { INSTANT_SEARCH_INDEX_NAME_BASE, INSTANT_SEARCH_PRESET_BASE } from 'src/app/pages/search/shared/consts';
import { useLocale } from 'src/app/shared/hooks/l10n';

type Result = ModelHookResult<{
	instantSearchIndexName: string;
	instantSearchPreset: string;
}>;

export function useInstantSearchIndexName(): Result {
	const locale = useLocale();
	const [language] = locale.split('-');
	const utilityContext = useUtilityContext();
	const demoNameSpace = utilityContext.environment.getApiDemoEnvironment();

	const shouldDemoNamespace = useCallback(
		(indexName: string): string => {
			return demoNameSpace ? `${demoNameSpace}_${indexName}` : indexName;
		},
		[demoNameSpace],
	);

	return {
		data: {
			instantSearchIndexName: useMemo(() => {
				return shouldDemoNamespace(`${INSTANT_SEARCH_INDEX_NAME_BASE}${language}`);
			}, [shouldDemoNamespace, language]),
			instantSearchPreset: useMemo(() => {
				return shouldDemoNamespace(`${INSTANT_SEARCH_PRESET_BASE}${language}`);
			}, [shouldDemoNamespace, language]),
		},
	};
}
